import { render } from "./AddClient.vue?vue&type=template&id=752a7e44&scoped=true&ts=true"
import script from "./AddClient.vue?vue&type=script&lang=ts"
export * from "./AddClient.vue?vue&type=script&lang=ts"

import "./AddClient.vue?vue&type=style&index=0&id=752a7e44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752a7e44"]])

export default __exports__